import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "../styles/Login.css";
import logo from "../assets/branding/logos/Kuddlecore-Transparent.png";
import { useAuth } from "../context/AuthContext";
import TurnstileWidget from "../components/auth/TurnstileWidget";
import openEye from "../assets/open-eye.png";
import closedEye from "../assets/closed-eye.png";
import {
  colors,
  typography,
  spacing,
  shadows,
  borders,
  gradients,
} from "../theme";

const Login = () => {
  const navigate = useNavigate();
  const { login, user, loading } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const [failedAttempts, setFailedAttempts] = useState(0);
  const [showTurnstile, setShowTurnstile] = useState(false);
  const [turnstileToken, setTurnstileToken] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (!loading && user) {
      navigate("/");
    }
  }, [loading, user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const payload = {
        email: email.trim().toLowerCase(),
        password,
      };

      const deviceToken = localStorage.getItem("kuddleDeviceToken");

      if (deviceToken) {
        payload.deviceToken = deviceToken;
      }

      if (showTurnstile) {
        payload.turnstileToken = turnstileToken;
      }

      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      console.log("LOGIN FULL RESPONSE:", data);

      console.log("LOGIN TOKEN:", data.token);
      console.log("LOGIN USER:", data.user);

      if (!res.ok) {
        const nextFailed = failedAttempts + 1;
        setFailedAttempts(nextFailed);

        if (data.requireTurnstile || nextFailed >= 3) {
          setShowTurnstile(true);
          setTurnstileToken("");
        }

        alert(data.message || "Login failed");
        return;
      }

      if (data.requiresDeviceTrust) {
        navigate("/trust-device", {
          state: {
            userId: data.userId,
            email: data.email,
            deviceLabel: data.deviceLabel,
            requiresTwoFactor: data.requiresTwoFactor,
          },
        });
        return;
      }

      if (data.requiresTwoFactor) {
        navigate("/verify-2fa", {
          state: {
            userId: data.userId,
            email: data.email,
          },
        });
        return;
      }

      if (!data.token || !data.user) {
        alert("Login response was incomplete. Please try again.");
        return;
      }

      setFailedAttempts(0);
      setShowTurnstile(false);
      setTurnstileToken("");

      sessionStorage.setItem("kuddleToken", data.token);
      sessionStorage.setItem("kuddleUser", JSON.stringify(data.user));

      login({
        user: data.user,
        token: data.token,
      });

      navigate("/");

    } catch (err) {
      console.error("Login error:", err);
      alert("Server error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-dots login-dots-left" />
      <div className="login-dots login-dots-right" />
      <div className="login-overlay" />

      <div className="login-card">
        <div className="login-brand">
          <img
            src={logo}
            alt="Kuddlecore Logo"
            className="login-logo"
          />
        </div>

        <div className="login-copy">
          <h2>Welcome Back</h2>
          <p>Sign in to access your center dashboard.</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <label className="login-field">
            <span>Email</span>
            <input
              type="email"
              placeholder="Enter your email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>

          <label className="login-field">
            <span>Password</span>
            <div className="password-input-wrap">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                required
              />

              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => setShowPassword(!showPassword)}
              >
                <img
                  src={showPassword ? closedEye : openEye}
                  alt="toggle password visibility"
                  className="password-toggle-icon"
                />
              </button>
            </div>
          </label>

          <div style={{ textAlign: "right", marginTop: -4 }}>
            <Link to="/forgot-password">Forgot password?</Link>
          </div>

          {showTurnstile ? (
            <div
              style={{
                marginTop: 12,
                minHeight: 78,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
              }}
            >
              <TurnstileWidget
                onVerify={(token) => setTurnstileToken(token)}
                onExpire={() => setTurnstileToken("")}
                onError={() => setTurnstileToken("")}
              />
            </div>
          ) : null}

          <button
            type="submit"
            className="login-button"
            disabled={submitting || (showTurnstile && !turnstileToken)}
          >
            {submitting ? "Signing in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;